import Vue from 'vue';
import { Module } from 'vuex';

import { Course, CoursesListState, RootState } from 'frontend/types';

const justLaunchedCourses: Module<CoursesListState, RootState> = {
  namespaced: true,
  state: () => ({
    items: [] as Course[],
  }),
  mutations: {
    setValue(state: CoursesListState, value: Course[]): void {
      Vue.set(state, 'items', value);
    },
  },
  getters: {
    justLaunchedCourseIds(state): number[] {
      return state.items.map(course => course.course_id);
    },
    isJustLaunchedCourse(state, getters): (course: Course) => boolean {
      return (course: Course) => getters.justLaunchedCourseIds.includes(course.course_id);
    },
  },
};

export default justLaunchedCourses;
